<nav role="navigation" aria-label="breadcrumbs">
	<div fxLayout="row" fxLayoutAlign="start center" style="width: 100%">
		<!-- Home button -->
		<button
			mat-button
			id="breadcrumb-trail-home-button"
			style="padding: 0px; min-width: 0"
			class="breadcrumb"
			(click)="goHome()"
			aria-label="Breadcrumb Home"
		>
			<fa-icon [icon]="$any(['fass', 'house'])"></fa-icon>
		</button>
		<span *ngFor="let item of itemArray">
			<breadcrumb-piece
				[breadcrumbItem]="item"
				[isActive]="isActiveItem(item)"
				(breadcrumbUpdated)="rebuildTrail($event)"
				aria-label="Breadcrumb Item"
			>
			</breadcrumb-piece>
		</span>
	</div>
</nav>
